export default "__VITE_ASSET__DPFONEq9__"